import { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { API } from "@/lib/api";

export const ScreenshotDialog = ({ payment, onClose, base = "/admin/payments" }) => {
  const { getToken } = useAuth();
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!payment) return;
    let blobUrl;
    setUrl(null); setFailed(false);
    (async () => {
      try {
        const res = await axios.get(`${API}${base}/${payment.id}/screenshot`, { headers: { Authorization: `Bearer ${await getToken()}` }, responseType: "blob" });
        blobUrl = URL.createObjectURL(res.data);
        setUrl(blobUrl);
      } catch { setFailed(true); }
    })();
    return () => blobUrl && URL.revokeObjectURL(blobUrl);
  }, [payment, getToken, base]);
  return (
    <Dialog open={!!payment} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg border-[#1F293D] bg-[#111827]" data-testid="screenshot-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl">UTR {payment?.utr}</DialogTitle></DialogHeader>
        {failed ? <p className="text-sm text-red-400">Could not load screenshot.</p>
          : url ? <img src={url} alt="Payment screenshot" className="max-h-[70vh] w-full rounded-lg object-contain" data-testid="screenshot-image" />
          : <p className="text-sm text-slate-500">Loading…</p>}
      </DialogContent>
    </Dialog>
  );
};
